import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, filter, map, Observable, startWith } from 'rxjs';
import { LoggingStyles } from '../models/logging-styles.model';

@Injectable({
	providedIn: 'root'
})
export class TransferOutStateService {
	public selectedEnvironment$: Observable<string>;
	public selectedExternalTransferId$: Observable<string>;
	public selectedSstnLoggingStyle$: Observable<string>;
	public selectedDhlLoggingStyle$: Observable<string>;
	public externalTransferHeadersPrerequisites$: Observable<[string, string, LoggingStyles]>;
	public atLeastOneLoggingStyle$: Observable<LoggingStyles>;
	public selectedBusinessUnit$: Observable<string>;

	public selectedExternalTransferId: BehaviorSubject<string | null> = new BehaviorSubject(null);
	public selectedEnvironment: BehaviorSubject<string | null> = new BehaviorSubject(null);
	public selectedSstnLoggingStyle: BehaviorSubject<string | null> = new BehaviorSubject(null);
	public selectedDhlLoggingStyle: BehaviorSubject<string | null> = new BehaviorSubject(null);
	public selectedBusinessUnit: BehaviorSubject<string | null> = new BehaviorSubject(null);

	public constructor() {
		this.selectedExternalTransferId$ = this.selectedExternalTransferId.pipe(filter((item) => item !== null));
		this.selectedSstnLoggingStyle$ = this.selectedSstnLoggingStyle.pipe(filter((item) => item !== null));
		this.selectedDhlLoggingStyle$ = this.selectedDhlLoggingStyle.pipe(filter((item) => item !== null));
		this.selectedBusinessUnit$ = this.selectedBusinessUnit.pipe(filter((item) => item !== null));
		this.selectedEnvironment$ = this.selectedEnvironment.pipe(filter((item) => item !== null));

		this.atLeastOneLoggingStyle$ = combineLatest([
			this.selectedSstnLoggingStyle.pipe(startWith(null)),
			this.selectedDhlLoggingStyle.pipe(startWith(null))
		]).pipe(
			filter(([sstn, dhl]) => (sstn !== undefined && sstn !== null) || (dhl !== undefined && dhl !== null)),
			map(
				([sstnLoggingStyle, dhlLoggingStyle]) =>
					new LoggingStyles({
						sstnLoggingStyle,
						dhlLoggingStyle
					})
			)
		);

		this.externalTransferHeadersPrerequisites$ = combineLatest([
			this.selectedEnvironment$,
			this.selectedBusinessUnit$,
			this.atLeastOneLoggingStyle$
		]);
	}

	public setExternalTransferId(description: string): void {
		this.selectedExternalTransferId.next(description);
	}

	public setEnvironment(environment: string): void {
		this.selectedEnvironment.next(environment);
	}

	public setBusinessUnit(environment: string): void {
		this.selectedBusinessUnit.next(environment);
	}

	public setDhlLoggingStyle(environment: string): void {
		this.selectedDhlLoggingStyle.next(environment);
	}

	public setSstnLoggingStyle(environment: string): void {
		this.selectedSstnLoggingStyle.next(environment);
	}

	public getSuggestedName(onlyStrctureOfWorkfile: boolean, selectedDescription: string[]): string {
		let suggestedWorkfileName = 'Workfile 1';

		if (!onlyStrctureOfWorkfile && selectedDescription && selectedDescription.length > 0) {
			return selectedDescription[0];
		}

		const workfileName: string[] = [];

		workfileName.push(this.selectedBusinessUnit.value);

		const dhlLoggingStyleItems: string | null = this.selectedDhlLoggingStyle.value;
		if (dhlLoggingStyleItems) {
			workfileName.push(dhlLoggingStyleItems);
		}

		const sstnLoggingStyleItems: string | null = this.selectedSstnLoggingStyle.value;
		if (sstnLoggingStyleItems) {
			workfileName.push(sstnLoggingStyleItems);
		}

		suggestedWorkfileName = `${workfileName.join('-')}-1`;

		return suggestedWorkfileName;
	}
}
